import React, { useState, useEffect, useRef } from 'react';
import { Input } from 'antd';
import { useLanguage } from '../../../contexts/LanguageContext';

const { TextArea } = Input;

const TableCellEditor = ({ formData, onFormChange }) => {
  const { t } = useLanguage();
  // 使用內部狀態來管理表單數據
  const [localFormData, setLocalFormData] = useState({});
  const textareaRef = useRef(null);
  // 追蹤當前組件的唯一標識，用於檢測組件切換
  const currentComponentId = useRef(null);
  
  // 當 formData 變化時，更新內部狀態
  useEffect(() => {
    if (formData && Object.keys(formData).length > 0) {
      // 使用 tagName + content 作為組件的唯一標識
      const componentId = `${formData.tagName || ''}_${formData.content || ''}`;
      
      // 如果組件改變了，重置並更新狀態
      if (currentComponentId.current !== componentId) {
        console.log('🔄 TableCellEditor 檢測到組件切換，更新 formData:', formData);
        setLocalFormData(formData);
        currentComponentId.current = componentId;
      } else {
        // 如果組件相同，直接更新
        console.log('🔄 TableCellEditor 檢測到數據變化，更新 formData:', formData);
        setLocalFormData(formData);
      }
    } else if (formData && Object.keys(formData).length === 0) {
      // 如果 formData 為空對象，重置
      console.log('⚠️ TableCellEditor 接收到空的 formData，重置狀態');
      setLocalFormData({});
      currentComponentId.current = null;
    }
  }, [formData]);
  
  // 優先使用 content，如果沒有則使用空字符串
  const currentValue = localFormData.content || '';

  // 處理內容變更
  const handleContentChange = (e) => {
    const newValue = e.target.value;
    console.log('📝 table cell 內容變更:', newValue);
    
    // 更新本地狀態
    setLocalFormData(prev => ({
      ...prev,
      content: newValue
    }));
    
    // 直接通知父組件更新 content 欄位
    onFormChange('content', newValue);
  };

  // 處理失去焦點
  const handleBlur = (e) => {
    const newValue = e.target.value;
    console.log('📝 table cell 內容失去焦點:', newValue);
    
    // 只在值真正改變時才更新
    if (newValue !== currentValue) {
      handleContentChange(e);
    }
  };

  // 安全地獲取 tagName，如果 formData 為 undefined 或 null，使用 localFormData
  const tagName = (formData && formData.tagName) || localFormData.tagName || 'td';

  return (
    <div>
      <h3 style={{ margin: '0 0 20px 0', color: '#333' }}>
        {tagName === 'th' ? t('eformDesigner.editTableHeader') || '編輯表格標題' : t('eformDesigner.editTableCell') || '編輯表格單元格'}
      </h3>
      
      <div style={{ marginBottom: '15px' }}>
        <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>
          {t('eformDesigner.cellContent') || '單元格內容'}:
        </label>
        <TextArea
          ref={textareaRef}
          value={currentValue}
          onChange={handleContentChange}
          onBlur={handleBlur}
          placeholder={t('eformDesigner.pleaseEnterCellContent') || '請輸入單元格內容...'}
          rows={3}
          style={{ resize: 'vertical' }}
        />
      </div>
      
      <div style={{ 
        marginTop: '15px', 
        padding: '10px', 
        backgroundColor: '#f5f5f5', 
        borderRadius: '4px',
        fontSize: '12px',
        color: '#666'
      }}>
        <strong>提示：</strong>修改此處的內容會立即更新表格單元格中的文字。
      </div>
    </div>
  );
};

export default TableCellEditor;
